'use client';

import {
  createContext,
  PropsWithChildren,
  useContext,
  useMemo,
  useState,
} from 'react';

interface GiftcardContextData {
  giftcard: AdaptedGiftcard;
  updateGiftcard(giftcard: AdaptedGiftcard): void;
}

const GiftcardContext = createContext({} as GiftcardContextData);

interface Props extends PropsWithChildren {
  giftcard: AdaptedGiftcard;
}

export const GiftcardContextProvider = (props: Props) => {
  const { children, giftcard } = props;

  const [giftcardState, setGiftcardState] = useState(giftcard);

  const updateGiftcard = (_giftcard: AdaptedGiftcard) => {
    setGiftcardState(_giftcard);
  };

  const value = useMemo(
    () => ({ giftcard: giftcardState, updateGiftcard }),
    [giftcardState],
  );

  return (
    <GiftcardContext.Provider value={value}>
      {children}
    </GiftcardContext.Provider>
  );
};

export const useGiftcard = () => useContext(GiftcardContext);
